import React, { useEffect, useMemo, useState } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import HeaderContainer from '../../../../components/shared/Header/Header.container';
import colors from '../../../../config/colors';
import WebHeader from '../../../../components/shared/Header/WebHeader.component';
import I18n from '../../../../components/shared/i18n/I18n.component';
import DataSummaryPanel from './DataSummaryPanel/DataSummaryPanel.component';

interface RepWorkingTimeReportsProps {
	companyTableData: any[];
	companyTableHeaders: any[];
	companyPieData?: any[];
	accountantTableData: any[];
	accountantTableHeaders: any[];
	accountantPieData?: any[];
	navigation?: any;
	companyExcelExportHandler?: Function;
	accountantExcelExportHandler?: Function;
}

const RepWorkingTimeReports = (props: RepWorkingTimeReportsProps) => {

	return (
		<>
			<HeaderContainer
				navigation={props.navigation}
				containerStyle={{ backgroundColor: colors.white }}
				component={WebHeader}
			/>

			<ScrollView style={styles.container}>
				<View style={{ marginBottom: 24 }}>
					<I18n size={36} weight='normal'>
						repReports.workingTimeReports.title
					</I18n>
				</View>

        		<View style={{ gap: 48 }}>

					<DataSummaryPanel
						title={'repReports.workingTimeReports.timeAndDelivery.Company'}
						pieTitle={'repReports.workingTimeReports.timeAndDelivery.CompanyChart'}
						tableHeaders={props.companyTableHeaders}
						tableData={props.companyTableData}
						pieData={props.companyPieData }
						tableClickable={false}
						footer={false}
						navigation={props.navigation}
						excelExportHandler={props.companyExcelExportHandler}
					/>

					<DataSummaryPanel
						title={'repReports.workingTimeReports.timeAndDelivery.Accountant'}
						pieTitle={'repReports.workingTimeReports.timeAndDelivery.AccountantChart'}
						tableHeaders={props.accountantTableHeaders}
						tableData={props.accountantTableData}
						pieData={props.accountantPieData }
						tableClickable={true}
						navigation={props.navigation}
						excelExportHandler={props.accountantExcelExportHandler}
					/>

        		</View>
			</ScrollView>
		</>
	);
};

const styles = StyleSheet.create({
	container: {
		paddingVertical: 8,
		paddingHorizontal: 32,
    	overflow: 'scroll',
	}
});

export default RepWorkingTimeReports;
